module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "holderInputs"
  }, [_c('v-card', {
    staticClass: "header-card",
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [(this.$store.state.isLowRes) ? _c('v-btn', {
    staticClass: "left-arrow-back",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.minimizeWindow.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "28px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "vtext-content",
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.getTitleMessage)
    }
  })])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "survey-content"
  }, [_c('star-rating', {
    staticClass: "star-rating-comp",
    attrs: {
      "show-rating": false,
      "increment": _vm.$store.state.campaign.fullStars == 0 ? 0.5 : 1
    },
    model: {
      value: (_vm.rating),
      callback: function($$v) {
        _vm.rating = $$v
      },
      expression: "rating"
    }
  }), _vm._v(" "), (_vm.$store.state.campaign.show_email) ? _c('v-switch', {
    staticClass: "switch-align",
    attrs: {
      "color": _vm.$store.state.campaign.color,
      "label": _vm.$t('sendbymail')
    },
    model: {
      value: (_vm.sendmail),
      callback: function($$v) {
        _vm.sendmail = $$v
      },
      expression: "sendmail"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "containerTextArea",
    staticStyle: {
      "padding": "9px 20px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('message'),
      "maxlength": "300",
      "counter": "300"
    },
    model: {
      value: (_vm.surveyMessage),
      callback: function($$v) {
        _vm.surveyMessage = $$v
      },
      expression: "surveyMessage"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(_vm.$store.state.campaign.color)
    }),
    attrs: {
      "id": "btnEnviar",
      "round": ""
    },
    on: {
      "click": _vm.clickSend
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('sendpunctuation')) + "  \n        "), _c('v-icon', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("send")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2954ae52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey.vue
// module id = 412
// module chunks = 2